import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'thehubz-asset-html-banner',
  templateUrl: './asset-html-banner.component.html',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatMenuModule, ClientCoreModule],
})
export class AssetHtmlBannerComponent implements AfterViewInit {
  @ViewChild('iframe') iframe!: ElementRef;
  @Input() asset!: AssetUIModel;
  @Input() toolbar = false;

  private metadata: AnyType;

  ngAfterViewInit(): void {
    this.metadata = this.asset.mainFile.metadata;
    this.reloadBannerIFrame();
  }

  reloadBannerIFrame() {
    const ele = this.iframe.nativeElement;
    ele.src = this.asset.previewUrl;
    if (this.metadata?.bannerMetadata?.width) {
      ele.width = this.metadata.bannerMetadata.width;
    }
    if (this.metadata?.bannerMetadata?.height) {
      ele.height = this.metadata.bannerMetadata.height;
    }
  }

  openBannerInNew() {
    window.open(this.asset.previewUrl, '_blank');
  }
}
